import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { AnimatedLogo } from "../components/site/AnimatedLogo";

export default function ThankYou() {
  const [p] = useSearchParams();
  const kind = p.get("t") === "quote" ? "quote request" : "order";
  return (
    <div className="mx-auto max-w-xl px-6 py-20 text-center" data-testid="thank-you-page">
      <AnimatedLogo className="mx-auto w-36" testId="thank-you-logo" />
      <CheckCircle2 className="mx-auto mt-6 h-12 w-12 text-emerald-400" />
      <h1 className="outline-title mt-4 text-5xl">Thank You!</h1>
      <p className="mt-4 text-lg font-semibold">Your {kind} was received.</p>
      <p className="mt-2 font-display text-3xl font-black text-[#E5202A]" data-testid="thank-you-number">{p.get("n")}</p>
      <p className="mt-4 text-sm text-slate-400">We'll review the details and artwork and reach out with an invoice or payment link. A confirmation email is on its way.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-ghost" data-testid="thank-you-home-button">Back Home</Link>
        <Link to="/work" className="btn-red" data-testid="thank-you-work-button">View Our Work</Link>
      </div>
    </div>
  );
}
